module.exports = __webpack_public_path__ + "static/03 - Chicago uni-490b5ab0c70c9574e06dd542f74e41b0.jpeg";